import {HeaderHeightCalculator} from '../../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/components/headerHeightCalculator';

export class ScrollToElement {
    constructor(element: HTMLElement) {
        const headerHeightCalculator = new HeaderHeightCalculator();
        element.scrollIntoView();
        window.scroll(0, window.scrollY - headerHeightCalculator.getHeaderHeight());
    }
}
